module.exports = __webpack_public_path__ + "img/home-answer.b61023ac.png";